import {useAccessToken, useUserClaimsData} from "../../services/auth"
import React from "react"
import {WirePayment} from "../../resources/payment"
import {WireReceivedPayment} from "../../resources/receivedPayments"
import {TabsMeta, TitleBarTabs} from "../../components/TitleBarTabs/TitleBarTabs"
import {startCase} from "lodash"
import {AssigneeType, AssignmentStage} from "../../resources/assignments"
import {IcomoonIconName} from "../../components/Icon/icons"
import {AssignmentsAmountIndicator} from "../../components/AssignmentAmountIndicator/AssignmentsAmountIndicator"

export enum PaymentTabConstants {
	FullWireDetails = "FullWireDetails",
	ActionsRequired = "ActionsRequired",
}

export default function PaymentTabs({
	currentTab,
	setCurrentTab,
	wirePayment,
	refreshToken,
}: {
	currentTab: PaymentTabConstants
	setCurrentTab: (tab: PaymentTabConstants) => void
	wirePayment: WirePayment | WireReceivedPayment
	refreshToken: number
}) {
	const accessToken = useAccessToken()
	const claims = useUserClaimsData()
	const assigneeType = startCase(claims.userType) as AssigneeType
	const liClassName = "payment-tab-li" as const
	const commonTabProps = {liClassName}
	const tabs: TabsMeta<PaymentTabConstants>[] = [
		{
			label: startCase(PaymentTabConstants.FullWireDetails),
			key: PaymentTabConstants.FullWireDetails,
			prefixIcon: "payment-box-incoming" as IcomoonIconName,
		},
		{
			label: startCase(PaymentTabConstants.ActionsRequired),
			key: PaymentTabConstants.ActionsRequired,
			prefixIcon: "dialpad--business-products" as IcomoonIconName,
			suffixElement: (
				<AssignmentsAmountIndicator
					findAssignmentsArgs={{
						approvals: wirePayment.relationships.approvals?.data.id,
						accessToken,
						assignees: [assigneeType],
						stages: [AssignmentStage.Pending],
						limit: 0,
					}}
					refreshToken={refreshToken}
					isActive={currentTab == PaymentTabConstants.ActionsRequired}
				/>
			),
		},
	].map((tab) => ({...tab, ...commonTabProps}))
	return <TitleBarTabs currentTab={currentTab} setCurrentTab={setCurrentTab} tabs={tabs} />
}
